import styled from "styled-components";

export const Container = styled.div`
    width: 100%;
    margin: 0 auto;
`;

export const StepContainer = styled.div`
    display: flex;
    justify-content: space-between;
    background: rgba(101, 34, 120, 0.1);
    padding: 12px;
    position: relative;
    :before {
    content: '';
    position: absolute;
    background: #652278;
    height: 4px;
    width: 100%;
    top: 50%;
    transform: translateY(-50%);
    left: 0;
    }
    :after {
    content: '';
    position: absolute;
    background: #652278;
    height: 4px;
    width: ${({ width }) => width};
    top: 50%;
    transition: 0.4s ease;
    transform: translateY(-50%);
    left: 0;
    }
`;


export const StepContentContainer = styled.div`
    padding: 12px 8px;
`;



export const StepTitleContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #652278;
`;

export const StepTitle = styled.span`
    font-weight: 700;
    font-size: 18px;
`;

export const CountText = styled.span`
    font-weight: 400;
    font-size: 14px;
`;

export const StepWrapper = styled.div`
    position: relative;
    z-index: 1;
`;

export const StepStyle = styled.div`
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: #ffffff;
    background:${({ step }) =>
    step === 'completed' ? '#652278' : '#999999'};
    transition: 0.4s ease;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const StepCount = styled.span`
    font-size: 19px;
    color: #FFF;
    font-weight: 700;
    @media (max-width: 600px) {
    font-size: 16px;
    }
`;

export const StepsLabelContainer = styled.div`
    position: absolute;
    top: 66px;
    left: 50%;
    transform: translate(-50%, -50%);
`;

export const StepLabel = styled.span`
    font-size: 19px;
    color: #4a154b;
    @media (max-width: 600px) {
    font-size: 16px;
    }
`;

export const ButtonsContainer = styled.div`
    display: flex;
    bottom:0;
    position:fixed;
    width:100%;
    min-width: 320px;
    max-width: 760px;
    justify-content: space-between;
    margin-top: 20px;
    padding-bottom: 5px; 
    background-color: #FFFF;
    border: 2px solid #EAEAEA;
`;
export const ButtonStyle = styled.button`
    width: 33%;
    border-radius: 4px;
    border: 0;
    background: #4a154b;
    color: #ffffff;
    cursor: pointer;
    padding: 20px;
    :active {
    transform: scale(0.98);
    }
    :disabled {
    background: #f3e7f3;
    color: #000000;
    cursor: not-allowed;
    }
`;

export const CheckMark = styled.div`
    font-size: 26px;
    font-weight: 600;
    color: #4a154b;
    display: flex;
    justify-Content: center;
    align-items: center;
`;

export const GroupInput = styled.div`
    margin: 0px 0px 32px 0px;
    display: flex;
    flex-direction: column;
`;

export const Label = styled.label`
    font-weight: 400;
    font-size: 16px;
    cursor: pointer;
`;

export const CheckBox = styled.input`
    margin: 0px 5px 0px 10px;
    cursor: pointer;
    width: 30px;
    height: 30px;
    border: 1px solid black;

    @media (min-width: 769px){
        width: 20px;
        height: 20px;
    }
`;